module.exports = __webpack_public_path__ + "assets/pencil-blue-8de02f.svg";